import React, { useEffect, useState } from 'react'

import { AiOutlinePlus } from 'react-icons/ai'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { processMediaUrl, simpleHash } from '../../../_helpers/utils'
import constant from '../../../_config/constant'
var Modal = require('react-bootstrap-modal')
import { UploadingView } from '../components/UploadingView'

export function AddPhotos({ onNext, onPrev, formData, setFormData, className, saveAsDraft, draftRequesting, photosUploadedKey }) {
    // const [photos, setPhotos] = useState(formData["photos"] || []);
    // const [photos, setPhotos] = useState([]);
    const [photos, setPhotos] = useState(
        formData['images'] && formData['images'].length
            ? formData['images'].map((e, i) => {
                  return {
                      type: 'url',
                      order: i + 1,
                      url: e,
                      id: simpleHash(e),
                  }
              })
            : []
    )
    const [dragId, setDragId] = useState(null)
    const [isDragging, setIsDragging] = useState(false)
    const [draggOverId, setDraggOverId] = useState(false)

    const [touchStart, setTouchStart] = useState(null)
    const [touchEnd, setTouchEnd] = useState(null)
    const [isMobile, setIsMobile] = useState(false)

    const [dragThumbnail, setDragThumbnail] = useState({
        show: false,
        x: 0,
        y: 0,
        photo: null
    })


    
    useEffect(() => {
        const checkMobile = () => {
            const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0
            const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            const isSmallScreen = window.innerWidth <= 768
            setIsMobile(hasTouchScreen && (isMobileUserAgent || isSmallScreen))
        }
        checkMobile()
        window.addEventListener('resize', checkMobile)
        return () => window.removeEventListener('resize', checkMobile)
    }, [])
    
    const [requesting, setRequesting] = useState(false)
    const [progressText, setProgressText] = useState('')

    useEffect(() => {
        setPhotos(formData['images'] && formData['images'].length
        ? formData['images'].map((e, i) => {
              return {
                  type: 'url',
                  order: i + 1,
                  url: e,
                  id: simpleHash(e)
              }
          })
        : [])
    }, [photosUploadedKey])


    const handleDrag = ev => {
        setIsDragging(true)
        setDragId(ev.currentTarget.id)
    }

    const handleDrop = ev => {
        const dragBox = photos.find(photo => photo.id === dragId)
        const dropBox = photos.find(photo => photo.id === ev.currentTarget.id)

        if (!dragBox || !dropBox) return
        const dragBoxOrder = dragBox.order
        const dropBoxOrder = dropBox.order

        const newPhotoState = photos.map(photo => {
            if (photo.id === dragId) {
                photo.order = dropBoxOrder
            }
            if (photo.id === ev.currentTarget.id) {
                photo.order = dragBoxOrder
            }
            return photo
        })

        setPhotos(newPhotoState)
        setIsDragging(false)
        setDragId(null)
        setDraggOverId(false)
        setFormData({ ...formData, photos: newPhotoState })
    }

    const handleTouchStart = (e, photoId) => {
        if (!isMobile) return
        
        const touch = e.touches[0]
        const draggedPhoto = photos.find(photo => photo.id === photoId)
       
        setTouchStart({
            x: touch.clientX,
            y: touch.clientY,
            id: photoId,
            time: Date.now()
        })
        setIsDragging(true)
        setDragId(photoId)

        if (draggedPhoto) {
            setDragThumbnail({
                show: true,
                x: touch.clientX,
                y: touch.clientY,
                photo: draggedPhoto
            })
        }
    }

    const handleTouchMove = (e) => {
        if (!isMobile || !touchStart) return
        
        const touch = e.touches[0]
        setTouchEnd({
            x: touch.clientX,
            y: touch.clientY
        })

        setDragThumbnail(prev => ({
            ...prev,
            x: touch.clientX,
            y: touch.clientY
        }))
        const thumbnail = document.querySelector('.thumbnail');
        const originalPointerEvents = thumbnail?.style?.pointerEvents;
        if(thumbnail) thumbnail.style.pointerEvents = 'none';
        const elementBelow = document.elementFromPoint(touch.clientX, touch.clientY);
        if(thumbnail) thumbnail.style.pointerEvents = originalPointerEvents;
        const targetPhotoElement = elementBelow?.closest('[data-photo-id]');
        
        if (targetPhotoElement) {
            const targetPhotoId = targetPhotoElement.getAttribute('data-photo-id')
            if (targetPhotoId !== touchStart.id) {
                setDraggOverId(targetPhotoId)
            }
        } else {
            setDraggOverId(false)
        }
    }

    const handleTouchEnd = (e, dropPhotoId) => {
        if (!isMobile || !touchStart || !touchEnd) {
            resetTouchState()
            return
        }

        const deltaX = Math.abs(touchEnd.x - touchStart.x)
        const deltaY = Math.abs(touchEnd.y - touchStart.y)
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY)
        const timeDiff = Date.now() - touchStart.time

        if (distance > 50 && timeDiff > 200) {
            const thumbnail = document.querySelector('.thumbnail');
            const originalPointerEvents = thumbnail?.style?.pointerEvents;
            if(thumbnail) thumbnail.style.pointerEvents = 'none';
            const elementBelow = document.elementFromPoint(touchEnd.x, touchEnd.y);
            if(thumbnail) thumbnail.style.pointerEvents = originalPointerEvents;
            const targetPhotoElement = elementBelow?.closest('[data-photo-id]');
            const targetPhotoId = targetPhotoElement?.getAttribute('data-photo-id');

            if (targetPhotoId && targetPhotoId !== touchStart.id) {
                const dragBox = photos.find(photo => photo.id === touchStart.id)
                const dropBox = photos.find(photo => photo.id === targetPhotoId)

                if (dragBox && dropBox) {
                    const dragBoxOrder = dragBox.order
                    const dropBoxOrder = dropBox.order

                    const newPhotoState = photos.map(photo => {
                        if (photo.id === touchStart.id) {
                            photo.order = dropBoxOrder
                        }
                        if (photo.id === targetPhotoId) {
                            photo.order = dragBoxOrder
                        }
                        return photo
                    })
                    setPhotos(newPhotoState)
                }
            }
        }

        resetTouchState()
    }

    const resetTouchState = () => {
        setTouchStart(null)
        setTouchEnd(null)
        setIsDragging(false)
        setDragId(null)
        setDraggOverId(false)
        setDragThumbnail({ show: false, x: 0, y: 0, photo: null })

    }

    const getImage = file => {
        let src = new FileReader()
        const url = URL.createObjectURL(file.current)
        return url
    }

    const handleDelete = id => {
        const arr = photos.filter(curr => curr.id !== id)
        setPhotos([...arr])
        setFormData({ ...formData, photos: [...arr] })
    }

    const handleNextStep = () => {
        setFormData({ ...formData, photos: photos })
        window.scrollTo({ top: 0, behavior: 'smooth' })

        if (photos.length > constant.PROPERTY_IMAGES_COUNT) {
            toast.error(`You can add upto ${constant.PROPERTY_IMAGES_COUNT} images while listing the property`)
            return
        }
        photos.length && onNext()
    }

    const saveAsdraft = () => {
        setFormData({ ...formData, photos: photos })
        // photos.length && saveAsDraft();
        if (photos.length > constant.PROPERTY_IMAGES_COUNT) {
            toast.error(`You can add upto ${constant.PROPERTY_IMAGES_COUNT} images while listing the property`)
            return
        }
        saveAsDraft({setProgressText})
    }

    return (
        <div className={className}>
            <div className=" ">
                <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
                    <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white tw-rounded-full">
                        4
                    </span>{' '}
                    Add Photos
                </h4>
                <div className="row gx-5">
                    <div className="tw-flex tw-items-start tw-flex-wrap tw-mb-4">
                        {photos
                            .sort((a, b) => a.order - b.order)
                            .map((curr, i) => {
                                return (
                                    <div
                                        key={`${curr.id}`}
                                        id={curr.id}
                                        data-photo-id={curr.id}
                                        draggable={true}
                                        onDragOver={ev => {
                                            ev.preventDefault()
                                            setDraggOverId(ev.target.id)
                                        }}
                                        onDragEnd={() => {
                                            setDraggOverId(false)
                                        }}
                                        onDragStart={handleDrag}
                                        onDrop={handleDrop}

                                        onTouchStart={isMobile ? (e) => handleTouchStart(e, curr.id) : undefined}
                                        onTouchMove={isMobile ? handleTouchMove : undefined}
                                        onTouchEnd={isMobile ? (e) => handleTouchEnd(e, curr.id) : undefined}
                                        
                                        className={`tw-w-44 tw-flex-shrink-0 tw-grow-0 tw-relative tw-cursor-move tw-h-44 tw-m-2 tw-object-cover tw-rounded-md tw-overflow-hidden ${
                                            (draggOverId === curr.id && isDragging) ? 'tw-bg-gray-400' : 'tw-bg-gray-300'
                                        } ${isDragging && dragId === curr.id ? 'tw-opacity-60 tw-scale-105 tw-shadow-lg tw-z-20' : ''} ${isDragging && draggOverId === curr.id && dragId !== curr.id ? 'tw-bg-blue-200 tw-scale-95' : ''}`}
                                        style={{
                                            transition: 'transform 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease',
                                            touchAction: isMobile ? 'none' : 'auto',
                                            userSelect: 'none',
                                            WebkitUserSelect: 'none',
                                            transform: isDragging && dragId === curr.id ? 'scale(1.05)' : 'scale(1)',
                                            zIndex: isDragging && dragId === curr.id ? 20 : 1
                                        }}
                                    >
                                        {i === 0 && (
                                            <div
                                                className=" tw-text-white tw-p-1"
                                                style={{
                                                    width: '70px',
                                                    textAlign: 'center',
                                                    fontSize: '13px',
                                                    borderRadius: '3px',
                                                    position: 'absolute',
                                                    top: 0,
                                                    backgroundColor:'#23426e',
                                                    zIndex: 10
                                                }}
                                            >
                                                Featured
                                            </div>
                                        )}
                                        <span
                                            onClick={() => handleDelete(curr.id)}
                                            className="tw-absolute tw-right-4 tw-top-4 tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-rounded-full tw-bg-gray-500 tw-bg-opacity-50 tw-z-10"
                                        >
                                            <AiOutlinePlus size={22} className="tw-transform tw-rotate-45 tw-text-white" />
                                        </span>

                                        <img
                                            id={curr.id}
                                            className="tw-w-full tw-h-full tw-object-cover tw-transition-opacity tw-duration-200"
                                            src={curr.type==='url' ? processMediaUrl(curr.url) : curr.previewUrl}
                                            style={{
                                                opacity: isDragging && draggOverId === curr.id && dragId !== curr.id ? '0.5' : '1',
                                                pointerEvents: 'none',
                                                userSelect: 'none',
                                                WebkitUserSelect: 'none',
                                                WebkitTouchCallout: 'none',
                                                WebkitUserDrag: 'none'
                                            }}
                                            onContextMenu={(e) => e.preventDefault()}
                                            draggable={false}
                                        />
                                    </div>
                                )
                            })}
                    </div>
                    {Boolean(photos.length) && (
                        <p className="tw-text-sm tw-text-gray-400 tw-my-2">ⓘ Drag photos to rearrange. First photo will be your cover photo</p>
                    )}

                    <div className="col-lg-6 mb-2">
                        <div className="mb-3">
                            <label className="text-label form-label">Add photos</label>
                            <div disabled={draftRequesting || requesting} className="tw-flex tw-items-center">
                                <label disabled={draftRequesting || requesting} htmlFor="add_photos" className={`btn btn-secondary btn-sm ${ (draftRequesting || requesting) ? 'tw-opacity-50 tw-pointer-events-none' : 'tw-pointer-events-auto tw-opacity-100'}`}>
                                    Choose
                                </label>
                                <p className="tw-text-base tw-ml-4">{!photos.length ? 'No file choosen' : `${photos.length} File choosen`}</p>
                            </div>
                            <input
                                id="add_photos"
                                type="file"
                                disabled={draftRequesting || requesting}
                                multiple
                                className="form-control tw-hidden"
                                required
                                accept="image/*"
                                onChange={async e => {
                                    setProgressText("0%")
                                    setRequesting(true)
                                    const getFile = async (file) => {
                                      return new Promise((resolve, reject) => {
                                        const canvas = document.createElement('canvas')
                                        const ctx = canvas.getContext('2d')
                                        const img = new Image()
                                  
                                        img.onload = function () {
                                          canvas.width = img.width
                                          canvas.height = img.height
                                          ctx.drawImage(img, 0, 0)
                                          canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 1)
                                        }
                                  
                                        img.onerror = function () {
                                          reject(new Error('Failed to load image'))
                                        }
                                  
                                        img.src = URL.createObjectURL(file)
                                      })
                                    }

                                    const files = Array.from(e.target.files)
                                    const totalFiles = files.length
                                    let completedFiles = 0
                                  
                                    const curr = await Promise.all(
                                      Array.from(e.target.files).map(async (file, i) => {
                                        const blob = await getFile(file)
                                        const previewUrl = URL.createObjectURL(blob)
                                                                                
                                        completedFiles++
                                        setProgressText(`${Math.round((completedFiles / totalFiles) * 100)}%`)
                                        
                                        return {
                                          current: blob,
                                          previewUrl,
                                          id: simpleHash(previewUrl),
                                          name: file.name,
                                          order: photos.length + i + 1,
                                        }
                                      })
                                    )
                                    setProgressText("100%")
                                    setPhotos([...photos, ...curr])
                                    setRequesting(false)
                                    setProgressText("")
                                    setFormData({ ...formData, photos: [...photos, ...curr] })
                                    e.target.value = ''
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {dragThumbnail.show && dragThumbnail.photo && (
                <div
                    className="thumbnail tw-fixed tw-pointer-events-none tw-z-50 tw-w-44 tw-h-44 tw-rounded-md tw-overflow-hidden tw-shadow-2xl tw-border-2 tw-border-blue-400 tw-bg-red-400"
                    style={{
                        background: '#ff0000',
                        left: dragThumbnail.x - 88,
                        top: dragThumbnail.y - 88,
                        opacity: 0.8,
                        zIndex: 99,
                    }}
                >

                    
                    <img
                        src={dragThumbnail.photo.type === 'url' 
                            ? processMediaUrl(dragThumbnail.photo.url) 
                            : dragThumbnail.photo.previewUrl
                        }
                        alt="Dragging"
                        className="tw-w-full tw-h-full tw-object-cover"
                        style={{
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            pointerEvents: 'none'
                        }}
                    />
                </div>
            )}
            <div className='tw-flex tw-flex-row tw-flex-wrap  tw-items-center tw-gap-2'>
                <button disabled={draftRequesting || requesting} onClick={onPrev} type="button" className="btn btn-secondary tw-mb-2">
                    Prev
                </button>
                <button disabled={draftRequesting || requesting} onClick={handleNextStep} type="button" className="btn btn-secondary tw-mb-2">
                    Next
                </button>
                <button type="button" disabled={draftRequesting || requesting} onClick={saveAsdraft} className="btn btn-secondary tw-mb-2">
                    {'Save as Draft'}
                </button>
                <div className={`${progressText != undefined && progressText != '' ? "" : "tw-hidden"}`}>
                    <UploadingView uploadingText={requesting ? 'Uploading ...' : "Saving ..."} progressText={progressText}/>
                </div>
            </div>
        </div>
    )
}
